jQuery(document).ready(function($) {

    // Funzione per filtrare le FAQ in base al prodotto selezionato
    function selectProduct() {
        let value = $('#faq-prodotti-select').val();

        // Nascondo tutto
        $(".faq-domanda-item").hide();
        $(".faq-sezione-titolo").hide();
        $(".faq-ancora-item").hide();

        if (value === "default") {
            // Mostro tutto se seleziono "default"
            $(".faq-domanda-item").show();
            $(".faq-ancora-item").show();
            $(".faq-sezione-titolo").show();
        } else {
            // Mostro solo gli elementi che contengono il prodotto selezionato
            $(".faq-domanda-item").each(function() {
                let prodotti = $(this).data('prodotti').toString().split(',');
                if (prodotti.includes(value)) {
                    $(this).show();
                    $(this).parent(".faq-sezione").children(".faq-sezione-titolo").show();
                }
            });

            $(".faq-ancora-item").each(function() {
                let prodotti = $(this).data('prodotti-ancor').toString().split(',');
                if (prodotti.includes(value)) {
                    $(this).show();
                }
            });
        }
    }

    // Bind all'evento change del select
    $('#faq-prodotti-select').on('change', selectProduct);

    // Mostra tutto all'inizio
    selectProduct();
});



document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".pagina-faq");

    if (!container) return;

    container.addEventListener("click", function (e) {
        const header = e.target.closest(".faq-domanda-header");
        if (!header) return;

        const headerId = header.id.replace("faq-header-", "");
        const body = document.getElementById("faq-body-" + headerId);
        if (!body) return;

        // SVG
        const arrowClosed = header.querySelector('.faq-arrow-closed');
        const arrowOpen = header.querySelector('.faq-arrow-open');

        if (body.classList.contains("open")) {
            // Chiusura
            body.style.maxHeight = body.scrollHeight + "px";
            body.offsetHeight;
            body.style.maxHeight = "0";
            body.classList.remove("open");
            // Cambia SVG
            if (arrowClosed && arrowOpen) {
                arrowClosed.style.display = '';
                arrowOpen.style.display = 'none';
            }
        } else {
            // Apertura
            body.classList.add("open");
            body.style.maxHeight = body.scrollHeight + "px";
            // Cambia SVG
            if (arrowClosed && arrowOpen) {
                arrowClosed.style.display = 'none';
                arrowOpen.style.display = '';
            }
            body.addEventListener("transitionend", function handler() {
                if (body.classList.contains("open")) {
                    body.style.maxHeight = "none";
                }
                body.removeEventListener("transitionend", handler);
            });
        }
    });
});




// WEBPACK FOOTER //
// ./js/widget/faq.js